import React, { useEffect } from "react";
import { useUserContext } from "../../_context/UserContext";
import { Link } from "react-router-dom";
import "../Admin/Admin.css"; // Reuse completely identical card grid styles!

/* ── SVG Icons ──────────────────────────────────────────── */
const FilePlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="12" y1="18" x2="12" y2="12" />
    <line x1="9" y1="15" x2="15" y2="15" />
  </svg>
);

const FileDigitIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <rect x="9" y="13" width="6" height="4" rx="1" />
  </svg>
);

const ArrowRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

/* ── Component ───────────────────────────────────────────── */
export const Reports = () => {
  const { setCurrentPage } = useUserContext();

  useEffect(() => {
    setCurrentPage("Reports Page");
  }, [setCurrentPage]);

  const REPORT_CARDS = [
    {
      label: "Create New Report",
      desc: "Start a new cleaning quality assessment",
      toPage: "select_client_for_new_report",
      icon: <FilePlusIcon />,
      iconTheme: "purple",
    },
    {
      label: "View Reports",
      desc: "Browse and manage previously submitted reports",
      toPage: "view_reports",
      icon: <FileDigitIcon />,
      iconTheme: "gold",
    },
  ];

  return (
    <div>
      {/* Welcome header */}
      <div className="admin-welcome">
        <span className="admin-welcome-eyebrow">CNA Cleaning Services</span>
        <h1 className="admin-welcome-title">Reporting Dashboard</h1>
        <p className="admin-welcome-subtitle">
          Create new quality assessments or review existing inspection reports.
        </p>
      </div>

      <div className="admin-divider" />

      {/* Action card grid */}
      <div className="admin-card-grid">
        {REPORT_CARDS.map((card) => (
          <Link
            key={card.toPage}
            to={card.toPage}
            className="admin-action-card"
          >
            <div>
              <div className={`admin-card-icon-wrap ${card.iconTheme}`}>
                {card.icon}
              </div>
              <p className="admin-card-label">{card.label}</p>
              <p className="admin-card-desc">{card.desc}</p>
            </div>
            <div className="admin-card-footer">
              <span className="admin-card-arrow">
                <ArrowRightIcon />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
